// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-career-section {
  width: 100%;
  min-height: 100vh;
  height: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("http://localhost:3000/images/round-bg.webp");
}

.padding-layout {
  padding: 1rem 1rem 4rem 1rem;
}

.career-div-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  justify-content: space-between;
  position: relative;
}

.career-select-btn-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  
}

.career-select-btn {
  background-color: #afb3ffa2;
  padding: 1rem;
  border-radius: 12px;
  border: 1px solid #a1a6fc;
  cursor: pointer;
  backdrop-filter: blur(8px);
}

.career-select-btn-selected {
  background-color: #f1efefad;
  border: 1px solid #afb3ff;
  padding: 1rem;
  border-radius: 12px;
  cursor: pointer;
  backdrop-filter: blur(8px);
}

.job-card h1,
h2,
h3,
p {
  margin: 0%;
}

.job-card p {
  font-size: 14px;
}

.career-details-container {
    width: 100%;
    padding: 1rem;
    border: 1px solid #a1a6fc;
    border-radius: 12px;
    /* background-color: rgba(209, 209, 209, 0.51); */
    background: linear-gradient(to right, #5b84f62e, #ffffff1e);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px); /* For Safari support */
  }

/* .job-details {

} */

.job-details-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
    background-color: #f1efefad;
    border-radius: 12px;
    padding: 1rem;
}

.apply-button {
  background-color: #8084FF;
  color: white;
  padding: 1rem 2rem;
  text-align: center;
  font-size: 16px;
  border: none;
  border-radius: 15px;
  cursor: pointer;
}

.apply-button:hover {
  background-color: rgba(120, 124, 255, 0.831)
}

.job-info {
  margin-top: 1rem;
}

.qualifications {
  margin-top: 1rem;
}

.qualifications h4 {
  margin-bottom: 0.5rem;
}

.job-description {
  margin-top: 2rem;
}

.job-description-flex {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.underline {
  text-decoration: underline;
}

.description-text {
  font-size: 14px;
  line-height: 1.5;
  margin-top: 0.5rem;
}

.qualifications-title {
  margin-top: 2rem;
  font-size: 20px;
  font-weight: bold;
}

.qualifications-list {
  list-style-type: disc;
  margin-left: 1.25rem;
  padding-bottom: 1.5rem;
}

.qualification-text {
  font-size: 12px;
  margin-top: 0.5rem;
}

.gradient {
  background: linear-gradient(to right, #5fd4ff, #035d55);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 700;
  font-size: 14px;
}

.job-summary {
  padding-top: 2rem;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

@media (min-width: 640px) {

}

@media (min-width: 768px) {
  
}

@media (min-width: 1024px) {
  .career-div-container {
    flex-direction: row;
  }
  .career-select-btn-container {
    width: 33.333333%;
  }
  .career-details-container {
    width: 66.666667%;
  }
  .career-select-btn-container {
    position: sticky; 
    top: 30px; 
    align-self: start;
    height: calc(100vh - 240px); 
    overflow-y: auto;
  }
}

@media (min-width: 1280px) {
  .padding-layout {
    padding: 5rem 2rem 5rem 2rem;
  }
}

@media (min-width: 1536px) {
  .padding-layout {
    padding: 4rem 8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Career/Career.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,mEAAmE;AACrE;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;;AAEX;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,iDAAiD;IACjD,2DAA2D;IAC3D,0BAA0B;IAC1B,kCAAkC,EAAE,uBAAuB;EAC7D;;AAEF;;GAEG;;AAEH;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uDAAuD;EACvD,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,SAAS;IACT,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".main-career-section {\n  width: 100%;\n  min-height: 100vh;\n  height: 100%;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-image: url(\"http://localhost:3000/images/round-bg.webp\");\n}\n\n.padding-layout {\n  padding: 1rem 1rem 4rem 1rem;\n}\n\n.career-div-container {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  justify-content: space-between;\n  position: relative;\n}\n\n.career-select-btn-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  \n}\n\n.career-select-btn {\n  background-color: #afb3ffa2;\n  padding: 1rem;\n  border-radius: 12px;\n  border: 1px solid #a1a6fc;\n  cursor: pointer;\n  backdrop-filter: blur(8px);\n}\n\n.career-select-btn-selected {\n  background-color: #f1efefad;\n  border: 1px solid #afb3ff;\n  padding: 1rem;\n  border-radius: 12px;\n  cursor: pointer;\n  backdrop-filter: blur(8px);\n}\n\n.job-card h1,\nh2,\nh3,\np {\n  margin: 0%;\n}\n\n.job-card p {\n  font-size: 14px;\n}\n\n.career-details-container {\n    width: 100%;\n    padding: 1rem;\n    border: 1px solid #a1a6fc;\n    border-radius: 12px;\n    /* background-color: rgba(209, 209, 209, 0.51); */\n    background: linear-gradient(to right, #5b84f62e, #ffffff1e);\n    backdrop-filter: blur(8px);\n    -webkit-backdrop-filter: blur(8px); /* For Safari support */\n  }\n\n/* .job-details {\n\n} */\n\n.job-details-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2rem;\n    background-color: #f1efefad;\n    border-radius: 12px;\n    padding: 1rem;\n}\n\n.apply-button {\n  background-color: #8084FF;\n  color: white;\n  padding: 1rem 2rem;\n  text-align: center;\n  font-size: 16px;\n  border: none;\n  border-radius: 15px;\n  cursor: pointer;\n}\n\n.apply-button:hover {\n  background-color: rgba(120, 124, 255, 0.831)\n}\n\n.job-info {\n  margin-top: 1rem;\n}\n\n.qualifications {\n  margin-top: 1rem;\n}\n\n.qualifications h4 {\n  margin-bottom: 0.5rem;\n}\n\n.job-description {\n  margin-top: 2rem;\n}\n\n.job-description-flex {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.underline {\n  text-decoration: underline;\n}\n\n.description-text {\n  font-size: 14px;\n  line-height: 1.5;\n  margin-top: 0.5rem;\n}\n\n.qualifications-title {\n  margin-top: 2rem;\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.qualifications-list {\n  list-style-type: disc;\n  margin-left: 1.25rem;\n  padding-bottom: 1.5rem;\n}\n\n.qualification-text {\n  font-size: 12px;\n  margin-top: 0.5rem;\n}\n\n.gradient {\n  background: linear-gradient(to right, #5fd4ff, #035d55);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.job-summary {\n  padding-top: 2rem;\n  font-size: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n@media (min-width: 640px) {\n\n}\n\n@media (min-width: 768px) {\n  \n}\n\n@media (min-width: 1024px) {\n  .career-div-container {\n    flex-direction: row;\n  }\n  .career-select-btn-container {\n    width: 33.333333%;\n  }\n  .career-details-container {\n    width: 66.666667%;\n  }\n  .career-select-btn-container {\n    position: sticky; \n    top: 30px; \n    align-self: start;\n    height: calc(100vh - 240px); \n    overflow-y: auto;\n  }\n}\n\n@media (min-width: 1280px) {\n  .padding-layout {\n    padding: 5rem 2rem 5rem 2rem;\n  }\n}\n\n@media (min-width: 1536px) {\n  .padding-layout {\n    padding: 4rem 8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
